module.exports = __webpack_public_path__ + "static/media/jennifer_ferreira.56b1e1c0.jpeg";